// extracted by mini-css-extract-plugin
export var backdropBlur = "_cr-0";
export var contentCard = "_cr-5";
export var frame = "_cr-2";
export var image = "_cr-4";
export var imagePane = "_cr-3";
export var modal = "_cr-1";